var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "36",
      "height": "36",
      "viewBox": "0 0 36 36",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "1.25",
      "y": "1.25",
      "width": "33.5",
      "height": "33.5",
      "rx": "16.75",
      "stroke": _vm.color,
      "stroke-width": "1.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.1364 9V13.6957M21.8636 9V13.6957M9.5 16.0435H26.5M13.3636 19.1739V20.7391M18 19.1739V20.7391M22.6364 19.1739V20.7391M22.6364 22.3043V23.8696M18 22.3043V23.8696M13.3636 22.3043V23.8696M9.5 11.3478H26.5V27H9.5V11.3478Z",
      "stroke": _vm.color,
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }